// import Navbar from "../components/navbar/navbarcopy";
import List from "./../components/projectcomponent/projects";
import Footer from "./../components/footer/footer";
import Header from "./../components/projectcomponent/header";
import Newsletter from "./../components/homecomponents/newsletter2";


const Project = () => {
    return(
        <div>
            {/* <Navbar/> */}
            <Header/>
            <List/>
            
            <Newsletter/>
            <Footer />
        </div>
    )
}
export default Project;